import React, { useEffect } from "react";
import Spinner from "../common/Spinner";
import BrusselItem from "./BrusselItem";
import { useSelector, useDispatch } from "react-redux";
import { getBrussels } from "../../actions/BrusselsActions";

export default function Brussels() {
  const brussel = useSelector((state) => state.brussel);
  const { brussels, loading } = brussel;
  console.log("val_brussels", brussel);

  let brusselsItems;

  if (brussels === null || loading) {
    brusselsItems = <Spinner />;
  } else {
    if (brussels.length > 0) {
      brusselsItems = brussels.map((brussel) => (
        <BrusselItem key={brussel._id} brussel={brussel} />
      ));
    } else {
      brusselsItems = <h4>No profiles found...</h4>;
    }
  }

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBrussels());
  }, [dispatch]);

  return <div>{brusselsItems}</div>;
}
